import {Howl, Howler} from 'howler';

class App
{
  // ---------------------------------------------------------------------------------------------------------
	// --	App
	// ---------------------------------------------------------------------------------------------------------

  constructor()
  {
    // console.log('slide.js');

    //スライド
    this.slide = $('.slide');

    //参照
    this.knob = $('.slide__slider-knob');

    //自動再生ボタン
    this.playBtn = $('.slide__btn--play');

    //プログレスバー
    this.progressL = $('.slide__progress--l >.inner');
    this.progressR = $('.slide__progress--r >.inner');
    TweenMax.set(this.progressL, {rotation:-180});
    TweenMax.set(this.progressR, {rotation:-180});

    //スライダー用の変数
    this.isDragging = false;
    this.prevX;
    this.knobX = 0;

    //自動再生フラグ
    this.isAutoPlaying = false;

    //バー初期表示
    $('.slide__slider-bar-inner').css('width', '0%');

    //ロード完了
    window.onload = this.onLoad.bind(this);
  }

  /**
   * ロード完了
   */
  onLoad(){

    //元のサイズを取得
    this.orgWidth = this.slide.outerWidth();
    this.orgHeight = this.slide.outerHeight();

    //リサイズのハンドリング
    $(window).resize(this.onResize.bind(this));
    this.onResize();

    //BGM初期化
    this.initSound();

    //JSONファイル読み込み
    $.getJSON("./images/slide/config.json" , this.onLoadJson.bind(this));
  }

  onLoadJson(data)
  {
    //コンフィグデータ保持
    this.config = data;

    //ページ数
    this.pageNum = this.config.pageNum;
    this.pageIndex = 1;

    //トータル時間を計算
    let totalSec = 0;
    for(let i=0; i<this.pageNum-1; i++)
    {
      totalSec += this.getDelay(i+1);
    }
    const min = Math.floor(totalSec / 60);
    const sec = totalSec % 60;
    let secString = sec;
    if(sec < 10) secString = '0' + sec;
    this.totalTime = min + ':' + secString;
    $('.slide__time').text(this.totalTime);

    //リストアイテム配置
    $('.slide__list').empty();
    for(let i=0; i<this.pageNum; i++)
    {
      $('.slide__list').append('<li class="slide__list-item"></li>');
    }
    
    //初期アップデート
    this.update();

    //ボタンアクション
    $('.slide__btn--prev').on('click', (e)=>{
      e.preventDefault();
      this.changePage(-1);
    });
    $('.slide__btn--next').on('click', (e)=>{
      e.preventDefault();
      this.changePage(1);
    });
    $('.slide__btn--sound').on('click', (e)=>{
      e.preventDefault();
      this.toggleSound();
    });
    $('.slide__btn--play').on('click', (e)=>{
      e.preventDefault();
      this.onTapPlayBtn();
    });

    //閉じるボタン
    $('.slide__close-btn >a').on('click', (e)=>{
      e.preventDefault();
      window.close();
    });

    //スライダー
    this.knob.on('touchstart', this.onStartDrag.bind(this));
    document.addEventListener('touchmove', this.onDrag.bind(this))
    document.addEventListener('touchend', this.onDragEnd.bind(this))
    this.knob.on('mousedown', this.onStartDrag.bind(this));
    document.addEventListener('mousemove', this.onDrag.bind(this))
    document.addEventListener('mouseup', this.onDragEnd.bind(this))

    //最後のページを初期化
    this.initLastPage()

    //一枚づつロード
    this.loadedCount = 0;
    this.loadNext();
  }

  loadNext()
  {
    //インデックス変更
    this.currentIndex = this.loadedCount + 1;

    //画像読み込み
    let image = new Image();
    image.onload = this.onImageLoaded.bind(this);
    image.src = this.getFilePath(this.currentIndex);
  }

  onImageLoaded(e)
  {
    //配置
    $('.slide__list-item').eq(this.currentIndex-1).append('<img src="' + this.getFilePath(this.currentIndex) + '">');

    //オプションセットアップ
    this.setupOption(this.currentIndex);

    //次を読み込
    if(++this.loadedCount < this.pageNum)
    {
      this.loadNext();
    }
    //全て読み込み完了
    else
    {
      //ラストページセットアップ
      this.setupLast()

      //スライドリンク設定
      $('.js-slide-link').on('click', function(e){
        e.preventDefault()
        window.open($(this).attr('href'),"","width=800,height=640,toolbar=no,menubar=no,location=no,status=no,scrollbars=no,resizable=no")
      })
    }

    //バーの更新
    const per = (this.loadedCount / this.pageNum)*100;
    $('.slide__slider-bar-inner').css('width', per + '%');
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	SLIDER
  // ---------------------------------------------------------------------------------------------------------

  onStartDrag(e)
  {
    e.preventDefault();

    //ドラッグスタート時の座標保持
    this.prevX = e.originalEvent.pageX;

    //フラグを立てる
    this.isDragging = true;

    //オートプレイ一時停止
    TweenMax.killTweensOf(this.progressL);
    TweenMax.killTweensOf(this.progressR);
    TweenMax.set(this.progressL, {rotation:-180});
    TweenMax.set(this.progressR, {rotation:-180});
  }

  onDrag(e)
  {
    e.preventDefault();

    if(!this.isDragging) return;

    //移動量計算
    const newX = e.pageX;
    const saX = newX - this.prevX;

    //新しい位置（制限つき）
    this.knobX += saX;
    if(this.knobX < 0)
    {
      this.knobX = 0;
    }
    else if(this.knobX > 350)
    {
      this.knobX = 350;
    }

    //ノブの位置アップデート
    TweenMax.killTweensOf(this.knob);
    TweenMax.set(this.knob, {x:this.knobX});

    //スライダーの位置をページに反映
    this.changePageBySlider(false);

    //前の座標を保持
    this.prevX = newX;
  }

  onDragEnd(e)
  {
    if(!this.isDragging) return;

    //フラグを戻す
    this.isDragging = false;

    //スライダーの位置をページに反映
    this.changePageBySlider(true);
  }

  //スライダーでページ変更
  changePageBySlider(bool)
  {
    //ノブの位置をページインデックスに反映
    this.pageIndex = Math.floor(this.pageNum*(this.knobX/350)) + 1;
    if(this.pageIndex > this.pageNum) this.pageIndex = this.pageNum;

    //アップデート
    this.update();

    //オートプレイ
    if(bool && this.isAutoPlaying)
    {
      if(this.pageIndex < this.pageNum)
      {
        this.autoPlay();        
      }
      else
      {
        this.stopAutoPlay();
        this.stopBgm();
      }
    }
  }

  
  // ---------------------------------------------------------------------------------------------------------
	// --	NEXT/BACK
  // ---------------------------------------------------------------------------------------------------------
  
  changePage(vec)
  {
    //ページインデックス変更
    this.pageIndex += vec;
    if(this.pageIndex < 1)
    {
      this.pageIndex = 1;
    }
    else if(this.pageIndex >= this.pageNum)
    {
      this.pageIndex = this.pageNum
    }

    //アップデート
    this.update();

    //オートプレイ
    if(this.isAutoPlaying)
    {
      if(this.pageIndex < this.pageNum) 
      {
        this.autoPlay();        
      }
      else
      {
        this.stopAutoPlay();
        this.stopBgm();
      }
    }
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	AUTO PLAY
  // ---------------------------------------------------------------------------------------------------------
  
  onTapPlayBtn()
  {
    //再生中は停止する
    if(this.playBtn.hasClass('playing'))
    {
      this.stopAutoPlay();
      this.stopBgm();
    }
    //停止中は再生する
    else
    {
      this.autoPlay();
      this.playBgm();
    }
  }

  autoPlay(delay = 0)
  {
    //ボタンの表示きりかえ
    this.playBtn.addClass('playing');

    //フラグを立てる
    this.isAutoPlaying = true;

    //delayの指定がなければConfigから読み込む
    if(delay == 0) delay = this.getDelay(this.pageIndex);
    console.log(this.pageIndex + '---delay:' + delay);

    //プログレス
    TweenMax.killTweensOf(this.progressL);
    TweenMax.killTweensOf(this.progressR);
    TweenMax.set(this.progressL, {rotation:-180});
    TweenMax.set(this.progressR, {rotation:-180});
    TweenMax.to(this.progressR, delay/2, {rotation:0, ease:Power0.easeNone});
    TweenMax.to(this.progressL, delay/2, {rotation:0, ease:Power0.easeNone, delay:delay/2, onComplete:()=>{
      this.changePage(1);
    }});
  }

  stopAutoPlay()
  {
    //ボタンの表示きりかえ
    this.playBtn.removeClass('playing');

    //自動再生停止
    TweenMax.killTweensOf(this.progressL);
    TweenMax.killTweensOf(this.progressR);
    TweenMax.set(this.progressL, {rotation:-180});
    TweenMax.set(this.progressR, {rotation:-180});

    //フラグをもどす
    this.isAutoPlaying = false;
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	UPDATE
	// ---------------------------------------------------------------------------------------------------------

  update()
  {
    //ページアップデート
    this.updatePage();

    //スライダーアップデート
    this.updateSlider();

    //UIアップデート
    this.updateUI();
  }

  //ページアップデート
  updatePage()
  {
    //自身参照
    const holder = this;

    //スライドの表示変更
    $('.slide__list-item').each(function(index){

      const item = $(this);
      if(index == (holder.pageIndex-1))
      {
        item.show();
      }
      else
      {
        item.hide();
      }
    });
  }

  //スライダーアップデート
  updateSlider()
  {
    //ノブの位置
    if(!this.isDragging)
    {
      this.knobX = Math.floor(350 * (this.pageIndex/this.pageNum));
      TweenMax.killTweensOf(this.knob);
      TweenMax.to(this.knob, 0.1, {x:this.knobX});
    }

    //ページ数更新
    $('.slide__slider-page').text(this.pageIndex + '/' + this.pageNum);
  }

  //UIアップデート
  updateUI()
  {
    if(this.pageIndex <= 1)
    {
      $('.slide__btn--prev').addClass('disactive');
    }
    else
    {
      $('.slide__btn--prev').removeClass('disactive');
    }

    if(this.pageIndex >= this.pageNum)
    {
      $('.slide__btn--next').addClass('disactive');
    }
    else
    {
      $('.slide__btn--next').removeClass('disactive');
    }
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	Option
  // ---------------------------------------------------------------------------------------------------------

  setupOption(index)
  {
    //オプションデータ取得
    const option = this.getOption(index);

    //オプションあり
    if(option)
    {
      // console.log('オプションあり：' + index);
      // console.log(option);

      switch(option.type){
        case 'link':
          this.setupLink(option);
          break;
      }
    }
  }

  getOption(index)
  {
    const len = this.config.options.length;
    for(let i=0; i<len; i++)
    {
      const option = this.config.options[i];
      if(option.page == index)
      {
        return option;
      }
    }

    return null;
  }

  setupLink(option)
  {
    //アイテム参照
    const item = $('.slide__list-item').eq(option.page-1);

    //リンク配置
    item.append(option.html);
  }

  setupLast()
  {
    //アイテム参照
    const item = $('.slide__list-item').eq(this.currentIndex-1);

    //外部ファイル読み込み
    $.ajax({
      url: './images/slide/last.html',
      cache: false,
      success: function(html){
        item.append(html);
        $('.slide__last-link').on('click', function(e){
          if(opener)
          {
            e.preventDefault()
            opener.location.href = $(this).attr('href')
            window.close()
          }
        })
      }
    });    
  }
  
  // ---------------------------------------------------------------------------------------------------------
	// --	最後のページ
  // ---------------------------------------------------------------------------------------------------------

  /**
   * 最後のページを初期化
   */
  initLastPage()
  {
    //参照
    const lastPage = $('.slide__list-item').eq(this.pageNum-1)

    //ローディング削除
    lastPage.css('background-image', 'none')

    //背景色
    lastPage.css('background-color', '#c4e1e1')
  }

  // ---------------------------------------------------------------------------------------------------------
	// --	Delay
  // ---------------------------------------------------------------------------------------------------------

  getDelay(index)
  {
    const len = this.config.delay.length;
    for(let i=0; i<len; i++)
    {
      const model = this.config.delay[i];
      if(model.page == index)
      {
        return model.delay;
      }
    }

    return 5;
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	SOUND
  // ---------------------------------------------------------------------------------------------------------

  initSound()
  {
    //フラグ
    let isMute = true;
    if(!$.cookie("MUTE") || $.cookie("MUTE") == 0)
    {
      isMute = false;
    }
    // $.removeCookie("MUTE");
    // $.removeCookie("MUTE", { path: '/' });
    // console.log($.cookie("MUTE"));
    console.log('isMute:' + isMute);
    // return;

    //BGM読み込み
    this.bgm = new Howl({
      src: ['../sound/bgm.wav', '../sound/bgm.mp3'],
      autoplay: false,
      loop: true,
      volume: (isMute)?0.0:0.5
    });

    if(isMute)
    {
      $('.slide__btn--sound').addClass('off');
    }
  }

  toggleSound()
  {
    const soundBtn = $('.slide__btn--sound');
    if(soundBtn.hasClass('off'))
    {
      this.unMuteBgm();
    }
    else
    {
      this.muteBgm();
    }
  }

  unMuteBgm()
  {
    const soundBtn = $('.slide__btn--sound');
    soundBtn.removeClass('off');
    this.bgm.volume(0.5);
    $.cookie("MUTE", 0, { path: '/' });
  }

  muteBgm()
  {
    const soundBtn = $('.slide__btn--sound');
    soundBtn.addClass('off');
    this.bgm.volume(0.0);
    $.cookie("MUTE", 1, { path: '/' });
  }

  playBgm()
  {
    console.log('playBgm')
    console.log(this.bgm.state())
    if(this.bgm.state() == 'unloaded')
    {
      console.log('サウンド読み込み')
      this.bgm.once('load', ()=>{
        console.log('soud on loaded')
        this.playBgm()
      })
      this.bgm.load()
      return
    }
    else
    {
      this.bgm.play()
    }
  }

  stopBgm()
  {
    this.bgm.stop();
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	Util
	// ---------------------------------------------------------------------------------------------------------

  getNumStr(index)
  {
    let numStr;

    if(index < 10)
    {
      numStr = '0000' + index;
    }
    else if(index < 100)
    {
      numStr = '000' + index;
    }
    else if(index < 1000)
    {
      numStr = '00' + index;
    }
    else if(index < 10000)
    {
      numStr = '0' + index;
    }
    else 
    {
      numStr = toString(index);
    }

    return numStr;
  }

  getFilePath(index)
  {
    if(index == this.pageNum)
    {
      return '../images/last.png';
    }
    else
    {
      const numStr = this.getNumStr(index);
      return './images/slide/scene' + numStr + '.png';
    }
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	リサイズ
  // ---------------------------------------------------------------------------------------------------------

  onResize(e)
  {
    const wW = window.innerWidth;
    const wH = window.innerHeight;

    let scale = wH / (this.slide.outerHeight()+40);
    if(scale > 1) scale = 1;

    TweenMax.set(this.slide, {scaleX:scale, scaleY:scale});
  }

  // ---------------------------------------------------------------------------------------------------------
}

// var app;
$(function(){
  window.app = new App();
});
